import React from 'react';
import _get from 'lodash/get';
import IconWarning from 'cccisd-icons/warning';

import style from './style.css';

// example: dateString = "2026-02-02"
export const isDateInPast = dateString => {
    const date = new Date(dateString);
    const today = new Date();

    today.setHours(0, 0, 0, 0);

    return date < today;
};

// only true when date passed in is a Monday today or in the future, and current local time is before 10am
export const isMonday = date => {
    // use EST as a base
    const nowEST = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/New_York' }));
    const isBefore10AMEST = nowEST.getHours() < 10;

    // set time to 0 after getting before10AM bool, to compare same date later on
    nowEST.setHours(0, 0, 0, 0);

    const selectedDate = new Date(date);
    selectedDate.setHours(0, 0, 0, 0);

    const selectedDateIsMonday = selectedDate.getDay() === 1;

    // if selected monday is today, only allow selecting if it is before 10am est
    if (selectedDateIsMonday && selectedDate.toDateString() === nowEST.toDateString() && !isBefore10AMEST) {
        return false;
    }

    return selectedDateIsMonday && selectedDate >= nowEST;
};

// example return value: "2026-02-16"
export const getFormattedDateForDB = date => {
    if (!date) {
        date = new Date();
    }

    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    const res = `${year}-${month}-${day}`;

    return res;
};

export const getPlanStatus = plan => {
    let status = '';

    if (plan.isClosed) {
        status = 'Completed';
    } else if (plan.isStopped) {
        status = 'Stopped';
    } else if (plan.hasNotOpenedYet) {
        status = 'Scheduled';
    } else {
        status = 'Active';
    }

    return status;
};

export function getLatestDate(dates) {
    if (!dates || dates.length === 0) return null;

    return dates.reduce((latest, current) => {
        const latestDate = new Date(latest);
        const currentDate = new Date(current);

        return currentDate > latestDate ? current : latest;
    });
}

// Returns first active or scheduled plan
export const getActivePlan = (youthPlans, pawnId) =>
    (_get(youthPlans, [pawnId], []) || []).find(plan => {
        const status = getPlanStatus(plan);
        return status === 'Active' || status === 'Scheduled';
    });

// Checks if youth or any caregiver can receive messages
export const canReceiveMessages = youth =>
    youth.receiveMessages || (youth.caregiverList || []).some(c => c.fields.receiveMessages);

// show correct name for plans ("onboarding" got changed to "standard")
export const switchPlanNameIfNeeded = planName => {
    switch (planName.toLowerCase()) {
        case 'onboarding':
            return 'Standard';

        default:
            return planName;
    }
};

export const noYouthWarning = ({ message, showIcon = true }) => {
    return (
        <div className={style.no_youth_found}>
            {showIcon && <IconWarning />}
            <span style={showIcon ? { marginLeft: '15px' } : {}}>{message}</span>
        </div>
    );
};
